import {createContext} from "react";

const UserContext = createContext({signedUser: false});
export default UserContext;